import React, { useEffect, useState } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Gamepad2, CheckCircle2, Play, Star } from "lucide-react";
import { KidQuiz } from './KidQuiz';

const API = process.env.REACT_APP_BACKEND_URL;

export const ParentActivitiesCard = ({ token }) => {
  const [items, setItems] = useState(null);
  const [active, setActive] = useState(null);

  const load = () => fetch(`${API}/api/activities/parent/items?token=${encodeURIComponent(token)}`)
    .then(r => (r.ok ? r.json() : { items: [] }))
    .then(d => setItems(d.items || []))
    .catch(() => setItems([]));
  useEffect(() => { if (token) load(); }, [token]);

  if (!items || items.length === 0) return null;
  const subjects = [...new Set(items.map(i => i.subject))];
  const done = items.filter(i => i.sub_status).length;

  return (
    <Card className="shadow-lg" data-testid="parent-activities-card">
      <CardHeader className="bg-violet-50">
        <div className="flex items-center justify-between">
          <CardTitle className="flex items-center gap-2"><Gamepad2 className="h-5 w-5 text-violet-600" /> Activities from the Teacher</CardTitle>
          <Badge variant="outline" data-testid="parent-activities-count">{done}/{items.length} done</Badge>
        </div>
        <CardDescription>Sit with your child and tap the answers together. Results go straight to the class teacher.</CardDescription>
      </CardHeader>
      <CardContent className="pt-4 space-y-4">
        {subjects.map(sub => (
          <div key={sub}>
            <p className="text-xs uppercase tracking-wide text-slate-500 mb-2">{sub}</p>
            <div className="space-y-2">
              {items.filter(i => i.subject === sub).map(it => (
                <div key={it.id} className="flex items-center gap-3 rounded-lg border p-3" data-testid={`parent-activity-${it.id}`}>
                  <span className="h-9 w-9 rounded-lg bg-violet-600 text-white font-bold flex items-center justify-center text-sm">{it.code}</span>
                  <div className="flex-1 min-w-0">
                    <p className="font-medium text-slate-900 truncate">{it.title}</p>
                    <p className="text-xs text-slate-500">{it.n_questions} questions{it.sub_status ? ` · ${Math.round(it.percentage)}% (${it.score}/${it.total_marks})` : ''}</p>
                  </div>
                  {it.sub_status ? (
                    <Badge className="bg-emerald-100 text-emerald-800 border-emerald-200" data-testid={`parent-activity-done-${it.id}`}><CheckCircle2 className="h-3.5 w-3.5 mr-1" />Done</Badge>
                  ) : (
                    <Button size="sm" className="bg-violet-600 hover:bg-violet-700" onClick={() => setActive(it)} data-testid={`parent-activity-start-${it.id}`}><Play className="h-4 w-4 mr-1" />Start</Button>
                  )}
                </div>
              ))}
            </div>
          </div>
        ))}
        <p className="text-xs text-slate-400 flex items-center gap-1"><Star className="h-3 w-3" /> Each activity can be completed once. The teacher can reopen it if needed.</p>
      </CardContent>
      {active && <KidQuiz token={token} item={active} onClose={() => { setActive(null); load(); }} />}
    </Card>
  );
};
